import './Avatar.css';

export default function Avatar() {
  return (
    <div className="text-center">
      <img
        src="https://avatars.githubusercontent.com/u/19491358"
        className="avatar"
        alt="Avatar"
      />
    </div>
  );
}